export default __webpack_public_path__ + "static/media/history_1980_00.ee65732d.png";